import { Variants } from "framer-motion";

// Optimized animation variants for better performance
// Using only GPU-accelerated properties (transform, opacity)
// Removed blur filter for better performance

export const fadeInUpVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94], // easeOutQuad
    },
  },
};

export const fadeInDownVariants: Variants = {
  hidden: {
    opacity: 0,
    y: -30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

export const scaleInVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.8,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

export const slideInVariants: Variants = {
  hidden: {
    opacity: 0,
    x: -30,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

// Legacy variants for backward compatibility (optimized)
export const headingVariants: Variants = {
  headingOffScreen: {
    opacity: 0,
    scale: 0.9,
    y: -30,
  },
  headingOnScreen: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

export const fadeInVariants: Variants = {
  fadeInOffScreen: {
    opacity: 0,
    scale: 0.9,
    y: 30,
  },
  fadeInOnScreen: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

export const imageVariants: Variants = {
  imageOffScreen: {
    scale: 0.9,
    opacity: 0,
  },
  imageOnScreen: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

// Viewport settings for better scroll performance
// margin only shrinks the vertical edges so narrow/mobile viewports and
// tall wrapper elements (e.g. Memberships' single full-page motion.div)
// can still reach the intersection amount required to trigger.
export const viewportSettings = {
  once: true,
  margin: "-100px 0px -100px 0px",
  amount: 0.1,
};
